module.exports = __webpack_public_path__ + "media/images/icons/therapists-9732c14a037a1f0a8e3354e8e33a03ad.svg";